import React, { useCallback, useState } from "react";
import styled from "styled-components";
import classLinkLogo from "../../../assets/image/classlink.png";
import {
  getClassLinkAuthUrl,
  getClassLinkClientId,
  getClassLinkRedirectUri,
  storeClassLinkState,
} from "../../../util/classLinkSSOConfig";
import {
  SSOButton,
  BUTTON_WIDTH,
} from "./ssoButtonStyles";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const ButtonColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
  max-width: ${BUTTON_WIDTH}px;
  margin: 0;
`;

const Logo = styled.img`
  width: 24px;
  height: 24px;
  object-fit: contain;
  flex-shrink: 0;
`;

const StatusText = styled.div`
  font-size: 13px;
  text-align: center;
  color: #1a2a3a;
`;

const ErrorBox = styled(StatusText)`
  background-color: #fdecef;
  color: #8b1e2f;
  border: 1px solid #f5c0c9;
  padding: 8px 10px;
  border-radius: 8px;
`;

const generateState = () => {
  if (typeof window !== "undefined" && window.crypto?.getRandomValues) {
    const array = new Uint32Array(4);
    window.crypto.getRandomValues(array);
    return Array.from(array, (val) => val.toString(16)).join("");
  }
  return Math.random().toString(36).slice(2, 18);
};

export default function ClassLinkSSOLogin() {
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const startClassLinkFlow = useCallback(() => {
    setErrorMsg("");
    const classLinkClientId = getClassLinkClientId();
    if (!classLinkClientId) {
      setErrorMsg("ClassLink SSO is not configured yet. Please contact support.");
      console.warn("[ClassLinkSSO] Missing client ID; aborting redirect.");
      return;
    }

    const state = generateState();
    storeClassLinkState(state);

    const redirectUri = getClassLinkRedirectUri();
    const authUrl = getClassLinkAuthUrl(state);

    if (!authUrl) {
      setErrorMsg("Unable to initiate ClassLink sign-in. Please try again later.");
      console.error("[ClassLinkSSO] Unable to construct auth URL.");
      return;
    }

    console.info("[ClassLinkSSO] Redirecting to ClassLink", {
      state,
      redirectUri,
      authUrl,
    });
    setLoading(true);
    window.location.assign(authUrl);
  }, []);

  return (
    <Wrapper>
      <ButtonColumn>
        <SSOButton onClick={startClassLinkFlow} disabled={loading}>
          <Logo src={classLinkLogo} alt="ClassLink" />
          <span>Continue with ClassLink</span>
        </SSOButton>
        {loading && <StatusText>Redirecting to ClassLink…</StatusText>}
        {errorMsg && <ErrorBox>{errorMsg}</ErrorBox>}
      </ButtonColumn>
    </Wrapper>
  );
}
